<template>
<div class="mb-2">
  <div class="relative tariff-common flex justify-between flex-wrap md:flex-no-wrap">
    <div class="text-primary font-bold flex-initial sm:w-auto w-1/4">{{$t('message.tariff.name')}}: </div>
    <div class="flex-initial sm:w-10/12 w-1/4 sm:text-left text-right">
      <TariffRtjs v-if="showRtjs" />
      <TariffCommon v-else />
    </div>
    <div class="flex-initial sm:w-1/12 sm:mx-2 w-full text-right">
      <router-link
        tabindex="-1"
        to="/tariffs/current">
        {{$t('message.tariff.detailed')}}
      </router-link>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import TariffCommon from '@/layouts/components/tariffs/TariffCommon'
import TariffRtjs from '@/layouts/components/tariffs/TariffRtjs'

export default {
  name: 'TariffHeaderWrapper',
  components: {TariffRtjs, TariffCommon},
  computed: {
    ...mapGetters('payment', ['getPaymentType', 'getLocalPayment']),
    showRtjs () {
      return !this.getLocalPayment && ['rtjs'].indexOf(this.getPaymentType) !== -1
    }
  }
}
</script>

<style scoped>

</style>
